import styled from "styled-components";
import {FC} from "react";

const UserMenu = styled.div`
  display: flex;
  font-size: 0.9em;
  justify-content: center;
  p {
    background: #fff;
    border: 1px solid #eee;
    border-radius: 10px;
    margin: 5px;
    text-align: center;
    a {
      display: block;
      padding: 10px 5px;
    }
  }
  p.selected_menu {
    background: #eee;
  }
  p:hover {
    text-decoration: underline;
  }
`;

type Props = {
  active?: "user_account" | "user_baby" | "user_save" | "user_message";
};

export const UserSubHeader: FC<Props> = ({active}) => {
  const menus = [
    {name: "user_account", label: "ユーザー設定", href: "/user_account"},
    {name: "user_baby", label: "ベイビー", href: "/user_baby"},
    {name: "user_save", label: "セーブ", href: "/user_save"},
    {name: "user_message", label: "メッセージ", href: "/user_message"},
  ];
  return (
    <UserMenu>
      {menus.map((m) => (
        <p key={m.name} className={active === m.name ? "selected_menu" : ""}>
          <a href={m.href}>{m.label}</a>
        </p>
      ))}
    </UserMenu>
  );
};
